module.exports = __webpack_public_path__ + "static/img/sjoberg_kho.c80e3f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sjoberg_kho.jpg
// module id = 380
// module chunks = 1